import { render } from "./Getknow.vue?vue&type=template&id=6a9f3428&scoped=true"
import script from "./Getknow.vue?vue&type=script&lang=js"
export * from "./Getknow.vue?vue&type=script&lang=js"

import "./Getknow.vue?vue&type=style&index=0&id=6a9f3428&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ynyan\\Desktop\\官网\\YNOfficialwebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a9f3428"]])

export default __exports__